import { Cookies } from 'react-cookie';

const cookies = new Cookies();

export const setCookie = (name, value, days) => {
  const expires = new Date();

  expires.setUTCDate(expires.getUTCDate() + days); //보관기한
  // expires.setTime(expires.getTime() + days * 60 * 1000); // 분 단위 만료 시간 설정
  // console.log(expires);
  return cookies.set(name, value, { path: '/', expires: expires });
};

export const getCookie = (name) => {
  return cookies.get(name);
};

export const removeCookie = (name, path = '/') => {
  cookies.remove(name, { path });
};
